import Axios from "axios";
import Constant from "../utils/constant";

const axios = Axios.create({
  baseURL: Constant.BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to include token dynamically
axios.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem("superUser"))?.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized - token might be expired
      console.error("Unauthorized access - token may be expired");
    }
    return Promise.reject(error);
  }
);

export default axios;
